import { useState } from 'react'
import { ConfigBot } from './ConfigBot/ConfigBot'
import { ConfigPanel } from './ConfigPanel/ConfigPanel'
import { AdminUser } from '../../../API/AdminInfo/models'
import { Row, Col, Nav, Tab, Card } from 'react-bootstrap'
import { AiFillLayout } from 'react-icons/ai'
import { FaRobot } from 'react-icons/fa'

interface ConfigProps {
    adminInfo: AdminUser | null;
    testToken: () => void;
}

export const Config = ({ adminInfo, testToken }: ConfigProps) => {
    const [activeTab, setActiveTab] = useState('bot');

    return (
        <div className="config-container pb-5">
            <Tab.Container activeKey={activeTab} onSelect={(selectedKey) => setActiveTab(selectedKey || "bot")}>
                <Row className="mb-4">
                    <Col md={12} sm={12}>
                        <Card className="border-0 shadow-sm">
                            <Card.Body className="p-0">
                                <Nav variant="pills" className="bg-dark rounded-3 p-2 d-flex flex-row justify-content-start">
                                    <Nav.Item className="mx-2">
                                        <Nav.Link
                                            eventKey="bot"
                                            className={`rounded-pill px-4 py-2 d-flex align-items-center gap-2 ${activeTab === "bot" ? "bg-primaryy text-white" : "text-white"}`}
                                        >
                                            <FaRobot size={20} className={activeTab === "bot" ? "text-white" : "text-primary"} />
                                            <span className='text-white'>Configuración del BOT</span>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item className="mx-2">
                                        <Nav.Link
                                            eventKey="panel"
                                            className={`rounded-pill px-4 py-2 d-flex align-items-center gap-2 ${activeTab === "panel" ? "bg-primaryy text-black" : "text-white"}`}
                                        >
                                            <AiFillLayout size={20} className={activeTab === "panel" ? "text-white" : "text-primary"} />
                                            <span className='text-white'>Configuración del Panel</span>
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <div className="bg-dark bg-opacity-25 p-4 rounded-3">
                            <Tab.Content>
                                <Tab.Pane eventKey="bot">
                                    <ConfigBot adminInfo={adminInfo} testToken={testToken} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="panel">
                                    <ConfigPanel adminInfo={adminInfo} />
                                </Tab.Pane>
                            </Tab.Content>
                        </div>
                    </Col>
                </Row>
            </Tab.Container>
        </div>
    )
}
